import { render } from "./messageUserPricing.vue?vue&type=template&id=88f26abe"
import script from "./messageUserPricing.vue?vue&type=script&lang=js"
export * from "./messageUserPricing.vue?vue&type=script&lang=js"

import "./messageUserPricing.vue?vue&type=style&index=0&id=88f26abe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__